import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import NewFicheForm from "../../../components/Forms/Fiche/NewFicheForm";
import {useParams, useHistory, Link} from 'react-router-dom'
import axios from 'axios'
import ProgressBar from "react-bootstrap/ProgressBar";
import {
    CONFIRM_EMAIL,
    RESEND_EMAIL,
    SEARCH_FICHE_BY_FORM_CODE,
    UPDATE_USER_PASSWORD,
    VALIDATE_USER_EMAIL
} from "../../../api/Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import Button from "@material-ui/core/Button";
import * as Yup from 'yup'
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {useDispatch, useSelector} from "react-redux";
import {actions as authActions} from "../../../modules/Auth/_redux/authRedux";
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1,1)
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(5,12)
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(10,20)
        },
    },
    table: {
        minWidth: 700,
    },
}));


const ValidationSchema = Yup.object().shape({
    code: Yup.string()
        .required('Champs obligatoire')

});



export default function EmailValidationPage(props){

    const {user} = useSelector(state => state.auth);
    const dispatcher = useDispatch()

    const [isSendingEmail,setIsSendingEmail] = React.useState();

    const [responseError,setResponseError] = React.useState();
    const [resendEmailResponseError,setResendEmailResponseError] = React.useState();

    const history = useHistory();

    const [isUpdatingPassword,setIsUpdatingPassword] = React.useState(false)

    async function confirmEmail(values,helpers){

        setResponseError()

        try {

            const response = (await axios.patch(
                CONFIRM_EMAIL,
                {
                    ...values
                }
            ));

            if (response.status === 200) {
                dispatcher(authActions.fulfillUser(response.data))
            } else {
                console.log('Some error happened when updating')
                //Display some error toast
            }


        } catch (e) {

            if(e.response)
                setResponseError(e.response)

            console.log("error",e.response)


        } finally {
            helpers.setSubmitting(false);
        }

    }


    async function resendEmail(){

        setResendEmailResponseError()
        setIsSendingEmail(true)

        try {

            const response = (await axios.get(
                RESEND_EMAIL,
            ));

            toast.success('Email de validation renvoyé avec succès', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (e) {

            if(e.response)
                setResendEmailResponseError(e.response)

            toast.error('Un problème est survenue pendant l\'envoie de l\'email', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            console.log("error",e.response)

        } finally {
            setIsSendingEmail(false)
        }

    }

    return (
        <div className="d-flex flex-column flex-root">
            {/*begin::Login*/}
            <div
                className="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                id="kt_login"
            >

                {/*begin::Content*/}
                <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
                    {/*begin::Content header*/}
                    {/*<div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">*/}
                    {/*  <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>*/}
                    {/*  <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link>*/}
                    {/*</div>*/}
                    {/*end::Content header*/}

                    {/* begin::Content body */}
                    <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">

                        <Formik
                            onSubmit={confirmEmail}
                            validationSchema={
                                ValidationSchema
                            }
                            initialValues={{
                                code: '',
                            }}
                        >
                            {
                                (formikHelpers) => {
                                    console.log(formikHelpers)
                                    return (

                                        <div>

                                            <div className={'h1 text-muted font-weight-lighter'}>
                                                Bienvenue <span className={'text-primary font-weight-bold'}>{user.nom} {user.prenoms}</span>
                                            </div>

                                            <div className={'small font-weight-bold my-5'}>
                                                <div>
                                                    Veuillez saisir le code envoyé à l'adresse <span className="text-primary font-weight-bold">{user.email}</span>
                                                </div>
                                            </div>

                                            {/*<div className="form-group fv-plugins-icon-container" style={{width: 390}}>*/}

                                            {/*    <label className="font-size-h6 font-weight-bolder text-primary">Mot de passe actuel</label>*/}
                                            {/*    <input*/}
                                            {/*        placeholder="Mot de passe"*/}
                                            {/*        type="password"*/}
                                            {/*        onChange={(event)=>formikHelpers.setFieldValue('currentPassword',event.target.value)}*/}
                                            {/*        className={`form-control form-control-solid h-auto py-7 px-6`}*/}
                                            {/*        name="password"*/}
                                            {/*    />*/}
                                            {/*    {formikHelpers.touched.currentPassword && formikHelpers.errors.currentPassword ? (*/}
                                            {/*        <div className="fv-plugins-message-container">*/}
                                            {/*            <div className="fv-help-block">{formikHelpers.errors.currentPassword}</div>*/}
                                            {/*        </div>*/}
                                            {/*    ) : null}*/}
                                            {/*</div>*/}

                                            <div className="form-group fv-plugins-icon-container">
                                                <label className="font-size-h6 font-weight-bolder text-primary">Code</label>

                                                <input
                                                    placeholder="Saisissez le code"
                                                    type="text"
                                                    value={formikHelpers.values.code}
                                                    onChange={(event)=>formikHelpers.setFieldValue('code',event.target.value)}
                                                    className={`form-control form-control-solid h-auto py-7 px-6`}
                                                    name="password"
                                                />
                                                {formikHelpers.touched.code && formikHelpers.errors.code ? (
                                                    <div className="fv-plugins-message-container">
                                                        <div className="fv-help-block">{formikHelpers.errors.code}</div>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div className={'text-right'}>
                                            </div>

                                            <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                                                {/*<Link*/}
                                                {/*  to="/auth/forgot-password"*/}
                                                {/*  className="text-dark-50 text-hover-primary my-3 mr-2"*/}
                                                {/*  id="kt_login_forgot"*/}
                                                {/*>*/}
                                                {/*  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />*/}
                                                {/*</Link>*/}

                                                <div className={'my-3'}>

                                                    <button
                                                        id="kt_login_signin_submit"
                                                        type="submit"
                                                        onClick={()=>formikHelpers.submitForm()}
                                                        disabled={formikHelpers.isSubmitting}
                                                        className={`btn btn-success font-weight-bold px-9 py-4`}
                                                    >
                                                        <span>Valider</span>
                                                        {formikHelpers.isSubmitting && <span className="ml-3 spinner spinner-white"></span>}

                                                    </button>

                                                    {
                                                        responseError && (
                                                            <div className={'text-danger font-weight-bold mt-3 small'}>
                                                                {
                                                                    responseError.data.errors.message
                                                                }
                                                            </div>
                                                        )
                                                    }

                                                </div>


                                                <BootstrapLoadingButton isLoading={isSendingEmail} onClick={resendEmail} className={'btn btn-light-primary mx-3 py-4'}>
                                                    Je n'ai pas reçu le code
                                                </BootstrapLoadingButton>

                                                <button
                                                    id="kt_login_signin_submit"
                                                    type="submit"
                                                    onClick={()=>{
                                                        history.push("/logout");
                                                    }}
                                                    className={`btn btn-danger small font-weight-bold px-9 py-4 my-3`}
                                                >
                                                    <span>Déconnexion</span>
                                                </button>
                                            </div>

                                        </div>

                                    )
                                }
                            }
                        </Formik>

                    </div>
                    {/*end::Content body*/}

                    {/* begin::Mobile footer */}
                    <div
                        className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                        <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                            &copy; 2020 Metronic
                        </div>
                        <div className="d-flex order-1 order-sm-2 my-2">
                            <Link to="/terms" className="text-dark-75 text-hover-primary">
                                Privacy
                            </Link>
                            <Link
                                to="/terms"
                                className="text-dark-75 text-hover-primary ml-4"
                            >
                                Legal
                            </Link>
                            <Link
                                to="/terms"
                                className="text-dark-75 text-hover-primary ml-4"
                            >
                                Contact
                            </Link>
                        </div>
                    </div>
                    {/* end::Mobile footer */}
                </div>
                {/*end::Content*/}
            </div>
            {/*end::Login*/}
        </div>
    );


}